"use client"

import Link from "next/link"
import { ShoppingBag } from "lucide-react"
import { useCart } from "@/lib/cart-store"
import { cn } from "@/lib/utils"

/**
 * Tiny cart icon with a counter badge — lives in the site header.
 * Hydrates client-side from localStorage, so SSR renders with no badge to
 * avoid hydration mismatch. Listens to the same `cart-updated` event that
 * useCart() emits so the badge updates instantly after add-to-cart.
 */
export function CartLink({ className }: { className?: string }) {
  const { totalItems, hydrated } = useCart()
  return (
    <Link
      href="/panier"
      className={cn(
        "relative inline-flex min-h-[44px] min-w-[44px] items-center justify-center rounded-full text-muted-foreground hover:text-foreground transition-colors duration-200",
        className,
      )}
      aria-label={`Panier${hydrated && totalItems > 0 ? ` (${totalItems} article${totalItems > 1 ? "s" : ""})` : ""}`}
    >
      <ShoppingBag className="size-5" />
      {hydrated && totalItems > 0 ? (
        <span
          aria-hidden
          className="absolute -top-0.5 -right-0.5 inline-flex min-w-[18px] items-center justify-center rounded-full bg-primary px-1 text-[10px] font-bold text-primary-foreground leading-[18px]"
        >
          {totalItems > 99 ? "99+" : totalItems}
        </span>
      ) : null}
    </Link>
  )
}
